const rgb = (value) => {
  const match = /^#([\da-f]{3}|[\da-f]{6})$/i.exec(`${value || ""}`.trim());
  const hex = match ? match[1] : "0099cc";
  const full = hex.length === 3 ? hex.split("").map((c) => c + c).join("") : hex;
  return [0, 2, 4].map((index) => parseInt(full.slice(index, index + 2), 16));
};

export const contrastOnWhite = (color) => {
  const [r, g, b] = rgb(color).map((value) => {
    const channel = value / 255;
    return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  return 1.05 / (0.2126 * r + 0.7152 * g + 0.0722 * b + 0.05);
};

// Keep the merchant hue, darkening only the ink used on white surfaces.
// Borders and decorative fills retain the original brand color.
export const accessibleThemeInk = (color) => {
  let channels = rgb(color);
  const hex = () => `#${channels.map((value) => value.toString(16).padStart(2, "0")).join("")}`;
  while (contrastOnWhite(hex()) < 4.5)
    channels = channels.map((value) => Math.floor(value * 0.95));
  return hex();
};
